import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=0788e5b2&scoped=true&"
import script from "./CButton.vue?vue&type=script&lang=ts&"
export * from "./CButton.vue?vue&type=script&lang=ts&"
import style0 from "./CButton.vue?vue&type=style&index=0&id=0788e5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788e5b2",
  null
  
)

export default component.exports